/* eslint-disable camelcase */
// 初始化数据
const modal = {
  searchResult: [], //查询结果数据
  searchParams: {}, // 搜索传值
  total: 0, // 查询总数
  page: 1, // 当前页码
  size: 10, // 当前分页数
  tableLoading: false, // 列表loading
  superClass: 0, //tool工具栏按钮状态
  selectedRowKeys: [], //table选中的数据
  selectedRowItems: [],
  tabList: [],
  statisticalData: null, //工具栏的所有金额合计
  statisticalData_min: null, //勾选的小计计算
  isNoPage: false,
  bansList: [], // 获取按钮级别权限
  statementNo: '',
};
export default modal;
